import React from "react";
import { CalendarCheck } from "lucide-react";
import { meta } from "../lib/text";
import { useApi } from "../hooks/useApi";
import { useLang } from "../i18n/LanguageContext";
import { StreakBadge } from "./StreakBadge";

export function MeetingsAttended() {
  const { t } = useLang();
  const { data } = useApi("/attendance/me");
  const list = data?.meetings_attended || [];
  return (
    <div className="glass rounded-2xl p-6 lg:col-span-2" data-testid="meetings-attended">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-serif-display text-xl font-bold text-crimson">{t("Meetings attended")}</h3>
          <p className="text-xs text-muted-foreground">{t("Every meeting you were checked in at. Only General Meetings and the AGM count toward the 50% rule.")}</p>
        </div>
        <div className="flex flex-col items-end gap-1">
          <span className="rounded-full bg-gold/25 px-3 py-1 font-mono-accent text-sm font-bold text-crimson" data-testid="meetings-attended-count">{list.length}</span>
          <StreakBadge streak={data?.streak} compact />
        </div>
      </div>
      <ul className="mt-4 max-h-72 divide-y divide-gold/15 overflow-y-auto text-sm">
        {list.map((m) => (
          <li key={m.id} className="flex items-center justify-between gap-3 py-2" data-testid={`attended-${m.id}`}>
            <div className="flex items-center gap-2"><CalendarCheck size={15} className="shrink-0 text-palm" />
              <div><div className="font-medium">{m.title}</div><div className="font-mono-accent text-xs text-muted-foreground">{meta(m.date, m.location)}</div></div></div>
            <span className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${m.counts_for_standing ? "bg-palm/15 text-palm" : "bg-stone-200 text-stone-600"}`}>
              {m.type_label}{m.counts_for_standing ? " ✓" : ""}
            </span>
          </li>
        ))}
        {data && list.length === 0 && <li className="py-6 text-center text-muted-foreground" data-testid="meetings-attended-empty">{t("No check-ins recorded yet.")}</li>}
      </ul>
    </div>
  );
}
